import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  ModalSuccessWithdrawVirtualAccount,
  DetailSuccessWithdrawVirtualAccount
} from './successWithdrawVirtualAccount.styles';

export default function SuccessWithdrawVirtualAccount(props) {
  const [successWithdrawVirtualAccount, setSuccessWithdrawVirtualAccount] = useState(
    props.showModalSuccessWithdrawVirtualAccount
  );
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    setSuccessWithdrawVirtualAccount(props.showModalSuccessWithdrawVirtualAccount);
  }, [props.showModalSuccessWithdrawVirtualAccount]);

  const closeModal = () => setSuccessWithdrawVirtualAccount(false);

  return (
    <ModalSuccessWithdrawVirtualAccount
      showModalSuccessWithdrawVirtualAccount={successWithdrawVirtualAccount}
    >
      <div>
        <div>
          <h3>Retirar desde Cuenta Virtual</h3>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
        </div>
        <DetailSuccessWithdrawVirtualAccount isAvailable={available}>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconoSuccessBlue.png`}
                alt="icono de éxito"
              />
            </figure>
            <p>Tu retiro desde tu Cuenta Virtual fue recibido con éxito.</p>
          </div>
          <Link to="/inversionista/dashboard">Cerrar</Link>
        </DetailSuccessWithdrawVirtualAccount>
      </div>
    </ModalSuccessWithdrawVirtualAccount>
  );
}
